let TimeZone = {
  info: function (date, tz, round) {
    let mom = moment(date).tz(tz || "GMT");
    let obj;
    let hour = {
      "DAY_START": 0,
      "DAY_END": 24,
      "HOUR_START": mom.hour(),
      "HOUR_END": mom.hour() + 1
    };

    if (round) {
      mom
        .hour(hour[round])
        .minute(0)
        .second(0)
        .millisecond(0);
    }

    obj = mom.toObject();
    obj.offset = mom.utcOffset() * 60000;
    obj.zoneAbbr = mom.zoneAbbr();
    obj.zoneName = mom.zoneName();
    obj.iso = mom.toISOString();
    obj.value = mom.valueOf();

    return obj;
  }
};

module.exports = TimeZone;